import moment from "moment";

const PER_PAGE = 15;

export const paginateItems = (items, page) => {
    const res = {};
    for (const key in items) {
        res[key] = items[key].slice(0, page * PER_PAGE);
    }
    return res;
};

const filterFunctions = {
    userId: (data, value) => data.filter((item) => value.includes(item.userId)),
    groupId: (data, value) => data.filter((item) => value.includes(item.groupId)),
    carId: (data, value) => data.filter((item) => value.includes(item.car?.id)),
    type: (data, value) => data.filter((item) => value.includes(item.type)),
    bidId: (data, value) => data.filter((item) => String(item.bidId).includes(value)),
    deadlineFrom: (data, value) => data.filter((item) => moment(item.deadline) >= moment(value)),
    deadlineBefore: (data, value) => data.filter((item) => moment(item.deadline) <= moment(value)),
};

export function filterItems(items, filters) {
    const newData = { ...items };
    for (const typeKey in newData) {
        Object.entries(filters).forEach(([key, value]) => {
            if (!filterFunctions[key]) {
                return;
            }
            newData[typeKey] = filterFunctions[key](newData[typeKey], value);
        });
    }
    return newData;
}
